import React from "react";
import clsx from "clsx";

import { FaqCategoryItem } from "../../types";
import styles from "../FaqCategoryItems.module.scss";

const Answer = () => (
  <div className={styles.answer}>
    <div className={styles.head}>
      <span className={styles.icon}>A</span>
      <p className={styles.text}>以下の項目をご確認ください。</p>
    </div>
    <div>
      <p className={styles.heading}>【学校管理者が行うこと（学校管理画面）】</p>
      <ul className={clsx(styles.list, styles.number)}>
        <li className={styles.item}>授業を実施する先生を登録する</li>
        <li className={styles.item}>
          教材を利用するクラスを登録する（授業担当者を必ず紐づける）
        </li>
        <li className={styles.item}>教材を利用する生徒を登録する</li>
        <li className={styles.item}>
          生徒配布用の仮パスワード（PDFファイル）をダウンロードし、各クラスへ配布する
          <br />
          ※「生徒登録」のページよりダウンロードが可能です。
        </li>
      </ul>
    </div>
    <div>
      <p className={styles.heading}>【授業担当者が行うこと（先生画面）】</p>
      <ul className={clsx(styles.list, styles.number)}>
        <li className={styles.item}>先生画面にログインする</li>
        <li className={styles.item}>
          教材を開放する（生徒が閲覧できる状態にする）
          <br />
          ※「Q. 生徒画面に教材が表示されない」を参照
        </li>
        <li className={styles.item}>
          教材をきちんと投影できるか/動画を再生できるか確認する
        </li>
      </ul>
    </div>
  </div>
);

export const REQUIRED_LESSON_SETTINGS_FAQ: FaqCategoryItem = {
  id: "required-lesson-settings-faq",
  question: "授業を実施するにあたり、最低限必要な設定項目を知りたい",
  Answer,
};
